import { BASE_ROUTE } from '@/config';
import { createBrowserHistory } from 'history';
export default createBrowserHistory({
    basename: BASE_ROUTE,
});
